import * as React from 'react';
import { CircularProgress } from '@mui/material';
import { connect } from "react-redux";
import { login } from '../../app/store/actions/authActions';
import { getNotificationsCount } from '../../app/store/actions/dataActions';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { cardShell, fieldLabel, fieldStyle, redCta } from '../../app/glass/styles';
import Hoverable from '../../app/glass/Hoverable';

export const LoginPartner = ({ login, user, token, isLoading, getNotificationsCount }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    login({ login: data.get('login'), password: data.get('password') });
  };

  React.useEffect(() => {
    if (!user) return;
    try { window.ReactNativeWebView.postMessage(token); } catch (err) { /* not in webview */ }
    getNotificationsCount({});
    navigate('/');
  }, [user]);

  if (isLoading) {
    return (
      <div style={{ display: 'grid', placeItems: 'center', minHeight: 240 }}>
        <CircularProgress sx={{ color: 'var(--red-tx)' }} />
      </div>
    );
  }

  return (
    <div style={{ ...cardShell, width: 'min(420px, 100%)', padding: '36px 32px' }}>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 18 }}>
        <img src={`${process.env.PUBLIC_URL || ''}/chainz-logo.png`} alt="Chainz" style={{ width: 72, height: 'auto' }} />
      </div>
      <div style={{ fontSize: 26, fontWeight: 600, textAlign: 'center', marginBottom: 6 }}>{t('auth.login')}</div>
      <div style={{ fontSize: 13, color: 'var(--mut)', textAlign: 'center', marginBottom: 24 }}>{t('auth.newToChainz')}</div>
      <form onSubmit={handleSubmit}>
        <div style={fieldLabel}>{t('auth.emailMobile')}</div>
        <input name="login" required autoComplete="email" autoFocus style={{ ...fieldStyle, marginBottom: 14 }} />
        <div style={fieldLabel}>{t('auth.password')}</div>
        <input name="password" type="password" required autoComplete="current-password" style={{ ...fieldStyle, marginBottom: 18 }} />
        <Hoverable as="button" type="submit" base={{ ...redCta, width: '100%', justifyContent: 'center', border: redCta.border }} hover={{}}>
          {t('auth.login')}
        </Hoverable>
      </form>
      <div style={{ display: 'flex', justifyContent: 'center', gap: 10, marginTop: 18 }}>
        <button type="button" className={`cz-chip ${i18n.language === 'en' ? 'on' : ''}`} onClick={() => i18n.changeLanguage('en')}>EN</button>
        <button type="button" className={`cz-chip ${i18n.language === 'ar' ? 'on' : ''}`} onClick={() => i18n.changeLanguage('ar')}>AR</button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state?.auth?.user,
  isLoading: state?.auth?.isLoading || state?.wait?.isLoading,
  token: state?.auth?.token
});

export default connect(mapStateToProps, { login, getNotificationsCount })(LoginPartner);
